import { PrettyHeader } from "../pretty-header/PrettyHeader";

import { AlertTriangle } from "react-feather";
import "./DangerZone.scss";

interface DangerZoneProps {
  label?: string;
  children: React.ReactNode;
}

export function DangerZone({ label, children }: DangerZoneProps) {
  return (
    <div data-component="DangerZone">
      <PrettyHeader
        icon={AlertTriangle}
        title="Danger zone"
        color="red"
        description={label || "As administrator, you can take destructive actions"}
      />
      <div className="danger-zone-content">
        {children}
      </div>
    </div>
  );
} 